<template>
    <div class="slide trivia-12">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="2"
                    :total="4"
                    :className="className" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-13",
            className: "trivia-12",
            currentTrivia: 12,
            questions: {
                question: {
                    "title": "If the incident was captured on CCTV, immediately preserve and maintain its integrity until the case reaches disposition by:",
                    "answers": [
                        {"key": "A", "answer": "Burning it onto a CD and securing it in your case file"},
                        {"key": "B", "answer": "Taking a video of it with your phone"},
                        {"key": "C", "answer": "Putting the tape in your pocket"},
                        {"key": "D", "answer": "Don’t tell anyone about it"}
                    ],
                    "correctAnswer": ["A"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-12 {
    padding: 20px 35px;

    h1 {
        font-size: 23px !important;
        line-height: 1.4;
    }
}
</style>
